import { useMutation, UseMutationOptions } from '@tanstack/react-query';

import {
  companyConfigurationService,
  UpdateCompanyConfigurationRequest,
  CompanyConfiguration,
} from '@aslanpay/portal-common-lib';

const useUpdateCompanyConfiguration = ({
  onSuccess,
  onError,
}: UseMutationOptions<CompanyConfiguration, Error, UpdateCompanyConfigurationRequest>) => {
  return useMutation<CompanyConfiguration, Error, UpdateCompanyConfigurationRequest>(
    ({
      id,
      reportsConfig,
      rewardsConfig,
      modulesConfig,
      earningsConfig,
      fileUploadConfig,
      digitalVouchersConfig,
      defaultAuthenticationMethod,
      generalCompanyConfiguration,
      rewardAndRecognitionConfig,
      savingsFeatureConfig,
      notificationsConfig,
    }: UpdateCompanyConfigurationRequest) =>
      companyConfigurationService.updateCompanyConfiguration({
        id,
        reportsConfig,
        rewardsConfig,
        modulesConfig,
        earningsConfig,
        fileUploadConfig,
        digitalVouchersConfig,
        defaultAuthenticationMethod,
        generalCompanyConfiguration,
        rewardAndRecognitionConfig,
        savingsFeatureConfig,
        notificationsConfig,
      }),
    { onSuccess, onError }
  );
};

export default useUpdateCompanyConfiguration;
